import { render, staticRenderFns } from "./CustomFieldsList.vue?vue&type=template&id=5ee1963e&scoped=true&"
import script from "./CustomFieldsList.vue?vue&type=script&lang=ts&"
export * from "./CustomFieldsList.vue?vue&type=script&lang=ts&"
import style0 from "./CustomFieldsList.vue?vue&type=style&index=0&id=5ee1963e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ee1963e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5ee1963e')) {
      api.createRecord('5ee1963e', component.options)
    } else {
      api.reload('5ee1963e', component.options)
    }
    module.hot.accept("./CustomFieldsList.vue?vue&type=template&id=5ee1963e&scoped=true&", function () {
      api.rerender('5ee1963e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_CustomFields/CustomFieldsList.vue"
export default component.exports